// eslint-disable-next-line import/prefer-default-export
export const DIGITAL_TRACE_STATUS = {
    Нет: 0,
    Собран: 1,
    Ошибка: 2,
    Отправлен: 3,
    Отклонен: 4,
    Принят: 5,
};

/*
Нет – у источника нет данных для сборки файла

Собран – у источника есть данные для сборки файла
Когда в шаблоне ЦС в модуле указано значение «нет» в поле «источник файла»
то статус ЦС = «собран» если файл фактически загружен

Ошибка – при попытке сборки файла или отправки ЦС произошла ошибка

Отправлен – после выполнения отправки ЦС в S3 и LRS

Отклонен – после ответа от LRS о том, что ей что-то не нравится в нашем ЦС

Принят – после ответа от LRS о том, что наш ЦС ей понравился
 */
